import {schema} from 'normalizr';

import schemaQuestion from "../../question/schema";

export default new schema.Entity('filtersQuestion', {
  question: schemaQuestion,
});